export const consumptionStatusTranslation = {
  pending: 'Pendente',
  complete: 'Concluído',
  failed: 'Falhou',
  default: ''
}
